var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { Text } from "../../../components/elements/Text";
import { Button } from "../../../components/elements/Button";
import IconWarningImage from "../../../../images/icone-check.svg";
import { Container, Wrapper, ContentContainer, InfoContainer, CheckImage, } from "../ConfirmEmailIncomplete/styles";
import { Card } from "../../../components/modules/Card";
export function ConfirmEmailSucess() {
    var navigate = useNavigate();
    return (_jsx(Container, { children: _jsx(Wrapper, { children: _jsx(Card, { children: _jsx(ContentContainer, { children: _jsxs(InfoContainer, { children: [_jsx(CheckImage, { src: IconWarningImage, alt: "success" }), _jsx(Box, __assign({ marginBottom: "2rem" }, { children: _jsx(Text, __assign({ textStyle: "subtitle1", color: "fakeBlack" }, { children: "E-mail confirmado com sucesso!" })) })), _jsx(Box, __assign({ marginBottom: "3rem" }, { children: _jsx(Text, __assign({ textStyle: "body1", color: "fakeBlack" }, { children: "Agora \u00E9 s\u00F3 come\u00E7ar a acumular seus pontos e aproveitar as as ofertas do 123milhas" })) })), _jsx(Box, __assign({ margin: "0 auto", width: "320px", maxWidth: "100%" }, { children: _jsx(Button, { children: "FAZER LOGIN", colorScheme: "gradient", buttonVariant: "h2", onClick: function () { return navigate("/login"); } }) }))] }) }) }) }) }));
}
